export default __webpack_public_path__ + "static/tkaczuk-103eb5e3d398526c069706dc4554f47f.jpg";